import React from 'react';
import { shape } from 'prop-types';
import AlarmsWarning from '@sma/components/device/alarms/alarmsWarning';

export const iconFlag = 'flag';

const JobHeader = ({ job }) => (
  <div className="device-title">
    <span>{job.jobId}</span>
  </div>
);

JobHeader.propTypes = {
  device: shape().isRequired,
};

export default JobHeader;
